import { Tab } from '@mui/material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box } from '@mui/material'
import { useState } from 'react'

export const DeckCanvasTab = ({ tablValue, setTabValue, twoDCanvas, threeDCanvas }) => {
  const [value, setValue] = useState(tablValue ?? '1')
  const handleChange = (event, newValue) => {
    setValue(newValue)
    setTabValue?.(newValue)
  }
  return (
    <TabContext value={value}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', display: 'flex' }} justifyContent="center">
        <TabList onChange={handleChange}>
          <Tab label="2D" value="1" />

          <Tab label="3D" value="2" />
        </TabList>
      </Box>
      <TabPanel
        sx={{
          height: '100%'
        }}
        value="1">
        {twoDCanvas}
      </TabPanel>
      <TabPanel
        sx={{
          height: '100%'
        }}
        value="2">
        {threeDCanvas}
      </TabPanel>
    </TabContext>
  )
}
